import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
    ChangePasswordActions,
    ChangePasswordEpics,
    ChangePasswordFacade,
    CustomerAuthActions,
    CustomerAuthFacade,
    LoginActions,
    LoginEpics,
    LoginFacade,
    OidcSignupModule,
    RecoverPasswordActions,
    RecoverPasswordEpics,
    RecoverPasswordFacade,
    RegisterActions,
    RegisterFacade
} from './+state';
import { AuthParametersActions, AuthParametersFacade } from './+state/auth-parameters';
import { AuthService } from './auth.service';
import { AuthGuard } from './guards/auth.guard';
import { Authenticator, SessionService } from './services';
import { AccountTicketsNgrxFacade } from '../account-tickets-ngrx';
import { PersonalizedGuard } from './guards/personalized.guard';

@NgModule({
    declarations: [],
    imports: [CommonModule, OidcSignupModule],
    providers: [
        Authenticator,
        AuthService,
        AuthGuard,
        AuthParametersActions,
        AuthParametersFacade,
        CustomerAuthActions,
        CustomerAuthFacade,
        LoginEpics,
        LoginFacade,
        LoginActions,
        RegisterFacade,
        RegisterActions,
        RecoverPasswordFacade,
        RecoverPasswordActions,
        RecoverPasswordEpics,
        ChangePasswordFacade,
        ChangePasswordActions,
        ChangePasswordEpics,
        SessionService,
        AccountTicketsNgrxFacade,
        PersonalizedGuard
    ]
})
export class AuthModule {}
